"use client";

import type { ReactNode } from "react";
import { useLang } from "@/lib/LanguageContext";
import { PageHero } from "./PageHero";
import { ServicesHeroFloatingCards } from "./ServicesHeroFloatingCards";

type HeroKey = keyof ReturnType<typeof useLang>["t"]["pageHeroes"];

export function TranslatedPageHero({
  heroKey,
  children,
}: {
  heroKey: HeroKey;
  children?: ReactNode;
}) {
  const { t } = useLang();
  const h = t.pageHeroes[heroKey];
  const bgImageMap: Partial<Record<HeroKey, string>> = {
    work: "tear.webp",
    websites: "workflow2.webp",
    digitalMarketing: "tool-stack.webp",
    contact: "communication.webp",
    projects: "tool-stack.webp",
    services: "workflow.webp",
  };

  return (
    <PageHero
      label={h.label}
      title={h.title}
      titleGradient={h.titleGradient}
      description={h.description}
      titleSize={heroKey === "services" ? "sm" : "default"}
      bgImage={bgImageMap[heroKey]}
      fullHeight={heroKey === "work"}
      compactMobile={heroKey === "contact"}
    >
      {heroKey === "services" && <ServicesHeroFloatingCards />}
      {children}
    </PageHero>
  );
}
